import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine';

import UI from '../../components/ExcerciseTypes/Design/UserInterface';

const json = {

  1: { // Exercise num
    unit: 'Unit 3',
    id: 'WB3-U3-P25-E1',
    audio: '',
    video: '',
    component: D1,
    checkUppercase: true,
    exerciseKey: 'img/FriendsPlus/Page25/E1/Key/Key.PNG',
    questionImage: [ // Row

      [
        // Column1
        { url: 'img/FriendsPlus/Page25/E1/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page25/E1/2.jpg' },
        { url: 'img/FriendsPlus/Page25/E1/3.jpg', input: true, answer: "I have an apple." },
        { url: 'img/FriendsPlus/Page25/E1/4.jpg' },
      ],
      [
        // Column1
        { url: 'img/FriendsPlus/Page25/E1/5.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page25/E1/6.jpg' },
        { url: 'img/FriendsPlus/Page25/E1/7.jpg', input: true, answer: "Do you have a sandwich?" },
        { url: 'img/FriendsPlus/Page25/E1/8.jpg' },
      ],
      [
        // Column1
        { url: 'img/FriendsPlus/Page25/E1/9.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page25/E1/10.jpg' },
        { url: 'img/FriendsPlus/Page25/E1/11.jpg', input: true, answer: "No, I don't." },
        { url: 'img/FriendsPlus/Page25/E1/12.jpg' },
      ],
      [
        // Column1
        { url: 'img/FriendsPlus/Page25/E1/13.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page25/E1/14.jpg' },
        { url: 'img/FriendsPlus/Page25/E1/15.jpg', input: true, answer: "Do you like yogurt?" },
        { url: 'img/FriendsPlus/Page25/E1/16.jpg' },
      ]
    ],
  },

  2: { // Exercise num
    unit: 'Unit 3',
    id: 'WB3-U3-P25-E2',
    audio: '',
    video: '',
    component: UI,
    exerciseKey: '',
    titleImage: '',
    hideBtnFooter: true,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page25/E2/1.jpg' },
      ],
      [
        // Column1
        { url: 'img/FriendsPlus/Page25/E2/2.jpg' },
      ]

    ],
  },

  3: { // Exercise num
    unit: 'Unit 3',
    id: 'WB3-U3-P25-E3',
    audio: '',
    video: '',
    // maxLength: 3,
    component: D1,
    exerciseKey: '',
    hideBtnFooter: true,
    questionImage: [ // Row

      [
        // Column1
        { url: 'img/FriendsPlus/Page25/E3/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page25/E3/2.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page25/E3/3.jpg' },
        { url: 'img/FriendsPlus/Page25/E3/4.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page25/E3/5.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page25/E3/6.jpg' },
        { url: 'img/FriendsPlus/Page25/E3/7.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page25/E3/8.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page25/E3/9.jpg' },
        { url: 'img/FriendsPlus/Page25/E3/10.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page25/E3/11.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page25/E3/12.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page25/E3/13.jpg' },
        { url: 'img/FriendsPlus/Page25/E3/14.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page25/E3/15.jpg' },
      ],
      [
        // Column8
        { url: 'img/FriendsPlus/Page25/E3/16.jpg' },
        { url: 'img/FriendsPlus/Page25/E3/17.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page25/E3/18.jpg' },
      ],
      [
        // Column9
        { url: 'img/FriendsPlus/Page25/E3/19.jpg' },
        { url: 'img/FriendsPlus/Page25/E3/20.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page25/E3/21.jpg' },
      ],
      [
        // Column10
        { url: 'img/FriendsPlus/Page25/E3/22.jpg' },
      ],

    ],
  },

}

export default json;